import _extends from "@babel/runtime/helpers/extends";
import { DonationBanner as Base } from "@cancer-council-queensland/react";
import { render } from "storyblok-rich-text-react-renderer";
import { jsx as _jsx } from "react/jsx-runtime";
export var DonationBanner = props => {
  return /*#__PURE__*/_jsx(Base, _extends({}, props, {
    content: render(props.content)
  }));
};
//# sourceMappingURL=donation_banner.js.map